function getParam(searchValue: string, param: string): string | null {
  const urlSearchParams = new URLSearchParams(searchValue)
  return urlSearchParams.get(param) || null
}

export function getUtmContent(searchValue: string = window.location.search): string | null {
  return getParam(searchValue, 'utm_content')
}

export function getUtmSource(searchValue: string = window.location.search): string | null {
  return getParam(searchValue, 'utm_source')
}

export function isCacheDisabledParamDefined(searchValue: string = window.location.search): boolean {
  const urlSearchParams = new URLSearchParams(searchValue)
  return urlSearchParams.get('cache_disabled') !== null
}
